module.exports = __webpack_public_path__ + "img/行业自律.89aa6e83.png";